import { serializeRowsToClipboardText } from "@/hooks/use-table-cell-selection";
import { Checkbox } from "@/styles/ui/checkbox";

export const copyTableToClipboard = async (
  tableElement: HTMLTableElement,
): Promise<boolean> => {
  try {
    const rows: string[][] = [];
    const tableRows = tableElement.querySelectorAll("tr");

    tableRows.forEach((tr) => {
      const row: string[] = [];
      const cells = tr.querySelectorAll("td");

      if (cells.length === 0) return;

      cells.forEach((cell) => {
        const cellElement = cell as HTMLTableCellElement;
        const text = cellElement.textContent?.trim() || "";
        const colspan = cellElement.colSpan || 1;

        row.push(text);
        for (let i = 1; i < colspan; i++) row.push("");
      });

      if (row.length > 0) rows.push(row);
    });

    if (rows.length === 0) return false;

    const maxLength = Math.max(...rows.map((row) => row.length));
    const normalizedRows = rows.map((row) => {
      while (row.length < maxLength) row.push("");
      return row;
    });

    await navigator.clipboard.writeText(
      serializeRowsToClipboardText(normalizedRows),
    );
    return true;
  } catch (error) {
    console.error("클립보드 복사 실패:", error);
    return false;
  }
};

export const TransposeToggle = ({
  transpose,
  setTranspose,
}: {
  transpose: boolean;
  setTranspose: (transpose: boolean) => void;
}) => {
  return (
    <div
      className="flex flex-row items-center gap-[12px] cursor-pointer"
      onClick={() => setTranspose(!transpose)}
    >
      <Checkbox
        className="w-[16px] h-[16px] border-neutral-200 rounded-[4px] data-[state=checked]:bg-blue-400 data-[state=checked]:border-blue-300 data-[state=checked]:text-white"
        checked={transpose}
      />{" "}
      행/열 전환
    </div>
  );
};
